class AflacBrandCenter {
   constructor(){

   }
   listeners(){
      $('.video_placeholder').on('click',function(event){
         event.preventDefault();
         let video_name = $(this).find('.video_title').html();
         $('#modal-wrapper').addClass('modal-showing');
         $('#video-wrapper').html(video_name+' video.');
      });
      $('.navigation-elements__child a').on('click',function(){
         $("#primary-navigation").removeClass("active");
      });
      $("#menu-toggle").on("click", function(event){
         event.preventDefault();
   		$("#primary-navigation").toggleClass("active");
   	});

   	$(".navigation-elements__parent > a.no-follow").on("click", function(event){
         event.preventDefault();
   		var $this = $(this);
         if(window.innerWidth <= 1024){
            if(!$this.parent().hasClass("active-child")){
               $('.active-child').removeClass('active-child');
               $this.parent().addClass("active-child");
            }else{
               $('.active-child').removeClass('active-child');
            }
         }else{
            $('.active-child').removeClass('active-child');
         }
   	});
      $("#close-modal").on("click",function(event){
         event.preventDefault();
         $('#modal-wrapper').removeClass('modal-showing');
      });

      $('.logo').on("click",function(event){
         event.preventDefault();
         var gotToURL = '/index.html';
         if($('body').hasClass('homepage')){
            gotToURL = 'http://aflac.com'
         }
         window.location = gotToURL;
      });
   }
}

$(document).ready(function(){
   let aflac_bc = new AflacBrandCenter();
   aflac_bc.listeners();
});
